export default {
  rfQuiz: {},
  mumQuiz: {},
  quizState: {
    rfQuiz: {},
    mumQuiz: {},
    lmQuiz: []
  }
};
